import {
  blue700,
  lightBlue900,
  peacockBlue,
  grey900,
  greyA100,
  white,
  grey100,
  yellow100,
} from './colors';

const ancillaries = {
  indicator: {
    isActive: lightBlue900,
    isNotActive: '#9e9e9e',
  },
  inactive: '#9e9e9e',
  active: peacockBlue,
  extrasCardText: grey900,
  extrasCardBackground: greyA100,
  popupText: grey900,

  bundleBanner: {
    background: '#fff6cc',
    mobileText: white,
  },

  bagsGrid: {
    backgroundColor: white,
    border: grey100,
    header: lightBlue900, //headerTextDesktop
    headerBackgroundMobile: blue700,
    includedLabel: lightBlue900,
    includedBackground: yellow100,
    text: grey900,
    subsectionBackground: greyA100,
    checkBoxBackground: greyA100,
    priceBackground: '#EAF2F9',
    strikeThrough: '#716f6f',
    savingSection: '#FAFBFB',
  },
};

export default ancillaries;
